import { useMutation, useQuery } from '@tanstack/react-query';
import {
  getWebsiteOwnershipConfig,
  saveWebsiteOwnershipConfig,
} from './websiteOwnershipConfigApi';

export const createWebsiteOwnershipConfigHooks = ({ queryClient }) => ({
  useGetWebsiteOwnershipConfig: () => useQuery({
    queryKey: ['website-ownership-config'],
    queryFn: getWebsiteOwnershipConfig,
  }),
  useSaveWebsiteOwnershipConfig: () => useMutation({
    mutationFn: saveWebsiteOwnershipConfig,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['website-ownership-config'] }),
  }),
});
